import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FontSizeIcon from 'remixicon-react/FontSizeIcon';
import Image2LineIcon from 'remixicon-react/Image2LineIcon';
import { useComposerConfig } from '../ComposerConfigContext';
import { useComposer } from '../hooks';
import { AttachmentPickerButton } from './AttachmentPickerButton';
import { ComposerIconButton } from './ComposerIconButton';
import { EmojiPickerButton } from './EmojiPickerButton';
import { SlashMenuButton } from './SlashMenuButton';
import { TextFormattingMenu } from './TextBubbleMenu';
export const ComposerControls = (props) => {
    const { action } = props;
    const { editor, onSlashMenuItemClick, toggleDialog, state } = useComposer();
    const { extensions } = useComposerConfig();
    if (!editor) {
        return null;
    }
    return (_jsxs("div", { className: "space-y-1", children: [editor && state.textFormatMenu && (_jsx(TextFormattingMenu, { editor: editor, className: "shadow-none border-none px-0 overflow-x-auto" }, void 0)), _jsxs("div", { className: "justify-between flex items-end", children: [_jsxs("div", { className: "flex space-s-1 sm:space-s-2 items-center", children: [_jsx(SlashMenuButton, { size: "sm", onItemClick: props => {
                                    setTimeout(() => {
                                        onSlashMenuItemClick({
                                            editor,
                                            props,
                                        });
                                    }, 100);
                                } }, void 0), _jsx(ComposerIconButton, { icon: FontSizeIcon, size: "sm", "aria-label": "text formatting", onClick: () => {
                                    toggleDialog('textFormatMenu', !state.textFormatMenu);
                                }, className: state.textFormatMenu
                                    ? 'bg-surface-subdued hover:bg-surface-hovered'
                                    : '' }, void 0), _jsx("div", { className: "hidden md:flex", children: extensions.emoji && (_jsx(EmojiPickerButton, { size: "sm", editor: editor }, void 0)) }, void 0), extensions.image && (_jsx(ComposerIconButton, { size: "sm", icon: Image2LineIcon, "aria-label": "image", onClick: () => {
                                    toggleDialog('image', true);
                                } }, void 0)), _jsx("div", { className: "hidden md:flex", children: extensions.attachment && _jsx(AttachmentPickerButton, { size: "sm" }, void 0) }, void 0)] }, void 0), action && _jsx("div", { className: "flex items-center ms-2", children: action }, void 0)] }, void 0)] }, void 0));
};
//# sourceMappingURL=ComposerControls.js.map